import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SelfDiagnosisEffects } from './effects';
import { reducer } from './reducer';
import { SelfDiagnosisFacade } from './facade';
import { stateName } from './selectors';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(stateName, reducer), EffectsModule.forFeature([SelfDiagnosisEffects])],
  exports: [],
  providers: [SelfDiagnosisFacade],
  declarations: [],
})
export class SelfDiagnosisStateModule {}
